import { render, staticRenderFns } from "./CoOrganizerModal.vue?vue&type=template&id=40a548c0"
import script from "./CoOrganizerModal.vue?vue&type=script&lang=js"
export * from "./CoOrganizerModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports